import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Dropdown } from "@faire/web--source/slate/Dropdown";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import retailerOrdersPath from "@faire/web-api--source/routes/www/user/account/orders";
import React, { type JSX } from "react";
import styled from "styled-components";

import { useLoggedOutIssuesDropdown } from "../hooks/useLoggedOutIssuesDropdown";

export const DropdownGroups: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const {
    issueL1,
    issueL2,
    issueL3,
    showDropdownL2,
    showDropdownL3,
    handleSelectL1,
    handleSelectL2,
    handleSelectL3,
    issuesFromL1,
    issuesFromL2,
    issuesFromL3,
    showGoToOrderPageCopy,
  } = useLoggedOutIssuesDropdown();
  return (
    <>
      <StyledDropdown
        value={issueL1}
        options={issuesFromL1}
        onSelect={handleSelectL1}
        placeholder={strictLocalize({
          defaultMessage: "Select a topic",
          description: { text: "text input placeholder to select a topic" },
        })}
        data-test-id="select-a-topic-dropdown"
      />
      {showGoToOrderPageCopy ? (
        <>
          <Spacer height="1x" />
          <Typography>
            <StrictLocalMsg
              defaultMessage="To report items or packages as missing or damaged, please go to the Orders page within your <LinkFormatting>Faire portal</LinkFormatting>."
              values={{
                LinkFormatting: LinkToRetailerOrders,
              }}
            />
          </Typography>
        </>
      ) : null}
      {showDropdownL2() ? (
        <>
          <Spacer height="2x" />
          <StyledDropdown
            value={issueL2}
            options={issuesFromL2}
            onSelect={handleSelectL2}
            placeholder={strictLocalize({
              defaultMessage: "Select an issue type",
              description: {
                text: "text input placeholder to select an issue type",
              },
            })}
            data-test-id="select-an-issue-type-dropdown"
          />
        </>
      ) : null}
      {showDropdownL3() ? (
        <>
          <Spacer height="2x" />
          <StyledDropdown
            value={issueL3}
            options={issuesFromL3()}
            onSelect={handleSelectL3}
            placeholder={strictLocalize({
              defaultMessage: "Choose a category",
              description: {
                text: "text input placeholder to choose a category",
              },
            })}
            data-test-id="choose-a-category-dropdown"
          />
        </>
      ) : null}
    </>
  );
};

const LinkToRetailerOrders = (chunk: JSX.Element) => (
  <Button variant="tertiary" linkTo={retailerOrdersPath()} target="__blank">
    {chunk}
  </Button>
);

const StyledDropdown = styled(Dropdown)`
  width: 100%;
`;
